import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Ul from '@adsk/bim360-matrix-react-ul';
import './_DropdownMenu.scss';

import objectValues from '@adsk/bim360-matrix-react-helpers/es/objectValues';

/**
 * A menu component which opens as a drop down and contains a list with items that can be selected
 */
export default class DropdownMenu extends Component {
  /**
   * renderChildren
   */
  renderChildren(children) {
    // Sometimes we can get null/undefined children (e.g when there's a Dropdown that some of it's elements are permission-based), so we need tho filter them out
    if (children && children.constructor === Array) {
      children = children.filter(child => child);
    }

    if (this.props.onSelect) {
      return React.Children.map(children, child => {
        return React.cloneElement(child, {
          onClick: this.props.onSelect
        });
      });
    }

    return children;
  }

  /**
   * render
   */
  render() {
    const floatDirection =
      this.props.float === DropdownMenu.FloatOptions.LEFT ? '--float-left' : '';

    const cx = classNames({ [`DropdownMenu${floatDirection}`]: true }, this.props.className);

    return <Ul className={cx}>{this.renderChildren(this.props.children)}</Ul>;
  }
}

DropdownMenu.FloatOptions = {
  RIGHT: 'RIGHT',
  LEFT: 'LEFT'
};

DropdownMenu.defaultProps = {
  className: ''
};

DropdownMenu.propTypes = {
  /**
   * Optional class name
   */
  className: PropTypes.string,
  /**
   * A callback which will be called when an item is selected
   */
  onSelect: PropTypes.func,
  /**
   * The items to render in the menu. Could be HTML elements or React components
   */
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  /**
   * The float direction of the menu
   */
  float: PropTypes.oneOf(objectValues(DropdownMenu.FloatOptions))
};
